// src/components/Loader/Loader.jsx
import * as React from "react";
import {
  Backdrop,
  CircularProgress,
  Box,
  Typography,
  useTheme,
} from "@mui/material";

import { DotsCotainer } from "./Loader.styles";

export const Loader = ({
  open,
  value = 0,
  label,
  progress,
  blurValue,
  bgOpacity = 0.5,
}) => {
  // Clamp value to [0, 100]
  const theme = useTheme();
  const v = Math.max(0, Math.min(100, Number(value) || 0));

  return (
    <Backdrop
      open={open}
      sx={{
        color: theme?.palette?.companyColors?.neutral,
        zIndex: (theme) => theme.zIndex.modal + 2,
        backdropFilter: `blur(${blurValue}px)`,
        background: `rgba(${theme?.palette?.companyColors?.secondaryRGB},${bgOpacity})`,
      }}
    >
      <Box
        sx={{
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          gap: 2,
          minWidth: 220,
        }}
      >
        {progress ? (
          <Box sx={{ position: "relative", display: "inline-flex" }}>
            <CircularProgress
              variant="determinate"
              enableTrackSlot
              value={v}
              thickness={4}
              size={80}
              sx={{ color: theme?.palette?.companyColors?.accent }}
            />
            <Box
              sx={{
                top: 0,
                left: 0,
                bottom: 0,
                right: 0,
                position: "absolute",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                fontWeight: 400,
                fontSize: "1.75rem",
              }}
            >
              {`${Math.round(v)}%`}
            </Box>
          </Box>
        ) : (
          <Box sx={{ position: "relative", display: "inline-flex" }}>
            <CircularProgress
              thickness={4}
              enableTrackSlot
              size={80}
              sx={{ color: theme?.palette?.companyColors?.accent }}
            />
          </Box>
        )}

        {label && (
          <Box
            sx={{
              display: "flex",
              flexDirection: "row",
              justifyContent: "center",
              alignItems: "flex-end",
            }}
          >
            <Typography
              variant="body2"
              sx={{ fontSize: "1.8rem", display: "flex" }}
            >
              {label}
            </Typography>
            <DotsCotainer>
              <Box component="span" className="loader__loading__dot">
                .
              </Box>
              <Box component="span" className="loader__loading__dot">
                .
              </Box>
              <Box component="span" className="loader__loading__dot">
                .
              </Box>
            </DotsCotainer>
          </Box>
        )}
      </Box>
    </Backdrop>
  );
};

export default Loader;
